var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useState } from "react";
import { Button, MessageBanner, ModalFooter } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation, useQueryClient } from "react-query";
import { createCollection } from "../../api/collectionsService";
import { createCollectionSchema } from "../../utils/validationUtils";
import { collectionInitialValues } from "../../utils/collectionInitialValues";
import { CollectionGeneralFields } from "../CollectionGeneralFields";
import { CollectionOtherLanguageNamesFields } from "../CollectionOtherLanguageNamesFields";
import css from "./InlineModal.module.css";
export var CreateCollectionForm = function (_a) {
    var onCreated = _a.onCreated, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var _b = useState(null), submitError = _b[0], setSubmitError = _b[1];
    var schema = useMemo(function () { return createCollectionSchema(formatMessage); }, [formatMessage]);
    var methods = useForm({
        resolver: zodResolver(schema),
        defaultValues: collectionInitialValues,
        mode: "onBlur",
    });
    var handleSubmit = methods.handleSubmit;
    var _c = useMutation(function (values) { return createCollection(ky, __assign(__assign({}, values), { version: 1 })); }, {
        onSuccess: function (created) {
            queryClient.invalidateQueries(["collections"]);
            onCreated(created);
        },
        onError: function () {
            setSubmitError(formatMessage({
                id: "ui-br-agency.title.collections.form.createCollection.error",
            }));
        },
    }), mutate = _c.mutate, isLoading = _c.isLoading;
    var onSubmit = function (values) {
        setSubmitError(null);
        mutate(values);
    };
    return (React.createElement(React.Fragment, null,
        submitError && (React.createElement(MessageBanner, { type: "error", className: css.errorBanner }, submitError)),
        React.createElement(FormProvider, __assign({}, methods),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(onSubmit) },
                React.createElement(CollectionGeneralFields, null),
                React.createElement(CollectionOtherLanguageNamesFields, null),
                React.createElement(ModalFooter, null,
                    React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit(onSubmit), disabled: isLoading },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })),
                    React.createElement(Button, { buttonStyle: "default", onClick: onCancel, disabled: isLoading },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })))))));
};
